import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBatchedConfigurationsByIds } from '@inter-ikea-guida/framework';
import config from '../config';
import { isInsightsQa } from '../utils';
import { getTagsForStorageNeed as getKeywordsForStorageNeed } from '../utils/storageNeedsHelper';
const API_URL = isInsightsQa() ? config.qaInsightsUrl : config.insightsurl;
const API_KEY = isInsightsQa() ? config.insightsDevApiKey : config.insightsApiKey;
/**
 * Type guard to check if the params is of corner type
 */
const isCornerProps = (params) => params.is_corner;
export const fetchIcfData = createAsyncThunk('icf/fetchIcfData', async (params, thunkApi) => {
    const queryParams = new URLSearchParams({
        width: params.width,
        height: params.height,
        depth: params.depth,
        door_type: params.door_type,
        include_signifiers: params.include_signifiers.toString(),
        is_corner: params.is_corner.toString()
    });
    if (isCornerProps(params)) {
        queryParams.append('width_right', params.width_adjacent_frame);
        queryParams.append('depth_right', params.depth_adjacent_frame);
    }
    // Get keywords for storage needs and combine them into a single array
    const signifierKeywords = params.storage_need?.flatMap(need => getKeywordsForStorageNeed(need, params)) ?? [];
    // If there are any storage needs entered, add corresponding keywords to the query
    if (signifierKeywords.length) {
        signifierKeywords.forEach(keyword => {
            queryParams.append('signifier_keywords', keyword);
        });
    }
    const query = queryParams.toString();
    const url = `${API_URL}?${query}`;
    const headers = {
        accept: 'application/json',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'X-API-Key': API_KEY
    };
    // Fetch the recommended designs from the insights API
    const response = await fetch(url, { headers, signal: thunkApi.signal });
    if (!response.ok) {
        throw new Error(`Failed to fetch data: ${response.statusText}`);
    }
    const responseData = await response.json();
    const orderedDesignList = responseData.ordered_design_list || [];
    const configurationIds = orderedDesignList.map(item => item.vpc);
    // Fetch the full VPC configurations for the designs
    const vpcConfigurations = await getBatchedConfigurationsByIds(configurationIds, config.dexfApiKey);
    const vpcToOrderedDesignList = orderedDesignList.map((item, index) => ({
        ...item,
        vpcData: vpcConfigurations[index]
    }));
    return {
        ...responseData,
        ordered_design_list: vpcToOrderedDesignList,
        default_order: vpcToOrderedDesignList
    };
});
//# sourceMappingURL=ml.js.map